<script lang="ts">
    import { useNavigate } from 'svelte-navigator';
    import { onMount } from 'svelte';

    export let to: string;

    const navigate = useNavigate();

    onMount(() => {
        navigate(to);
    });
</script>
